import React, { Component } from 'react';
import Chart from 'chart.js';
import { Tooltip } from 'antd';
import Skeleton from 'react-loading-skeleton';
import { DS_CHART_TOKENS, chartDownloadFileName, getCanvasChartColor, getDsChartColor } from '../../../utils/chartTheme';
import { DownloadPngButton } from '../pngExport';

class DoughnutGraph extends Component {
  nodeRef = React.createRef();

  componentDidUpdate() {
    this.drawGraph()
  }
  componentDidMount() {
    this.drawGraph()
  }
  drawGraph() {
    if (this.props.loading) return;

    let { graphData } = this.props;
    Chart.Tooltip.positioners.cursor = function (chartElements, coordinates) {
      //used to style coordinates(position) of tooltip
      if (coordinates.y <= 100 && coordinates.y > 75) coordinates.y = 75;
      else if (coordinates.y > 100 && coordinates.y < 140) coordinates.y = 140;
      return coordinates;
    };
    var ctx = document.getElementById(this.props.id).getContext('2d');
    new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: graphData.map((item) => item.text),
        datasets: [
          {
            label: 'Health Check Distribution',
            data: graphData.map((item) => item.number),
            backgroundColor: graphData.map((item) => getCanvasChartColor(item.color)),
            borderColor: getCanvasChartColor(DS_CHART_TOKENS.paper),
            borderWidth: 2,
          },
        ],
      },
      options: {
        tooltips: {
          mode: 'label',
          position: 'cursor',
        },
        elements: {
          arc: {
            borderWidth: 2,
            borderColor: getCanvasChartColor(DS_CHART_TOKENS.paper),
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        responsive: true,
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: 'Health Check Distribution',
        },
        cutoutPercentage: 68,
        animation: {
          duration: 700,
          easing: 'easeOutQuart',
        },
      },
    });
  }

  getTotalCount() {
    const { graphData } = this.props;
    if(this.props.title === 'Employees affected') return graphData[2].percentage + "%"
    else if (this.props.title === 'Fully vaccinated') return graphData[2].percentage +"%"
    var count = 0;
    graphData.forEach((item) => {
      count += item.number;
    });
    return count;
  }

  render() {
    if (this.props.loading) {
      return <Skeleton width='100%' height={this.props.loaderHeight} />;
    }

    let { graphData, title } = this.props;

    return (
      <div ref={this.nodeRef} className={`relative flex flex-row bg-white border border-gray-200 rounded-[14px] p-6 pr-0 shadow-sm ` + this.props.classes}>
        <div className='absolute right-2 top-2 z-10' data-download-ignore='true'>
          <DownloadPngButton nodeRef={this.nodeRef} fileName={chartDownloadFileName(title, 'utilization-split')} />
        </div>
        <div className='flex flex-col items-center justify-center'>
          <div className='text-2xl font-semibold -mt-5 text-gray-900 absolute font-jetbrains-mono tabular-nums tracking-tight'>{this.getTotalCount()}</div>
          <div className='text-[11px] text-gray-500 mt-7 w-24 text-center pt-4 absolute align-center font-medium'>{title}</div>
          <div className='myChartDiv'>
            <canvas id={this.props.id} width='250' height='250'></canvas>
          </div>
        </div>
        <div className={`grid justify-between items-center mx-auto ` + (graphData.length > 5 ? 'grid-cols-2 ' : '')}>
          {graphData.map((item, index) => {
            return (
              <div className={`flex flex-row ` + (index % 2 === 0 && graphData.length > 5 ? 'mr-5' : ' ')} key={`${item.text}-${index}`}>
                <Tooltip
                  placement={this.props.tooltip_placement}
                  title={item.tooltip}
                  color='var(--paper)'
                  overlayInnerStyle={{
                    color: 'var(--ink)',
                    border: '1px solid var(--gray-300)',
                    boxShadow: 'var(--sh-md)',
                    fontFamily: 'Inter, sans-serif',
                  }}
                >
                  <div className='h-2 w-2 rounded-full mt-1.5' style={{ backgroundColor: getDsChartColor(item.color) }}></div>
                </Tooltip>
                <div className='flex flex-col ml-3'>
                  <div className='text-sm font-semibold text-gray-900 leading-none mb-1 font-jetbrains-mono tabular-nums'>
                    {' '}
                    {item.number} ({item.percentage > 0 ? item.percentage : '<1'}%)
                  </div>
                  <div className='text-[11px] text-gray-500'> {item.text}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

DoughnutGraph.defaultProps = {
  classes: '',
};

export default DoughnutGraph;
